import {
    calendarPrintSettingsViewDay,
    calendarPrintSettingsViewWeek,
    calendarPrintSettingsViewSchoolWeek,
    calendarPrintSettingsViewWorkWeek,
    calendarPrintSettingsViewMonth,
} from './getViews.locstring.json';
import loc from 'owa-localize';
import { DateRangeType } from '..';
import { isEduStudent } from 'owa-bpos-utils';

/** Returns localized options for calendar print views. */
export function getViews(hideWorkWeekView: boolean) {
    let views = [
        { key: DateRangeType.Day, text: loc(calendarPrintSettingsViewDay) },
        { key: DateRangeType.Week, text: loc(calendarPrintSettingsViewWeek) },
    ];

    if (!hideWorkWeekView) {
        views.push({
            key: DateRangeType.WorkWeek,
            text: isEduStudent()
                ? loc(calendarPrintSettingsViewSchoolWeek)
                : loc(calendarPrintSettingsViewWorkWeek),
        });
    }

    views.push({ key: DateRangeType.Month, text: loc(calendarPrintSettingsViewMonth) });
    return views;
}
